import LoginResultModel from "../model/login_result_model";

export const toLoginResultModel = (object) => {
    return new LoginResultModel({
        success: object.success ?? false,
        id: (object.success && Array.isArray(object.data) && object.data.length > 0)
            ? object.data[0]?.userId ?? ""
            : "",
        token: (object.success && Array.isArray(object.data) && object.data.length > 0)
            ? object.data[0]?.token ?? ""
            : "",
        message: object.message ?? ""
    });
};